import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/global-main-frontend/global-main-frontend/application/layouts/default.vue").then(m => m.default || m)),
  "pricing-checkout": defineAsyncComponent(() => import("/home/runner/work/global-main-frontend/global-main-frontend/application/layouts/pricing-checkout.vue").then(m => m.default || m))
}